import React from "react";
import FrameworkCard from "../Sections/FrameworkCard";
import "./Framework.css";
import { MessageCircle, Sparkles, Bell, Heart } from "lucide-react";

export default function Framework() {
  const cards = [
    {
      icon: <MessageCircle size={42} color="#4DD2FF" />,
      title: "Discover",
      description:
        "Guests connect via WhatsApp to explore rooms, availability, or dining – anywhere, anytime.",
      glow: "rgba(77, 210, 255, 0.9)",
    },
    {
      icon: <Sparkles size={42} color="#FFD580" />,
      title: "Personalize",
      description:
        "AI Squared tailors experiences automatically – remembering preferences and anticipating needs.",
      glow: "rgba(255, 213, 128, 0.9)",
    },
    {
      icon: <Bell size={42} color="#F6C256" />,
      title: "Elevate",
      description:
        "Guests enjoy intelligent service, orders, spa bookings, and feedback handled with grace and precision.",
      glow: "rgba(246, 194, 86, 0.9)",
    },
    {
      icon: <Heart size={42} color="#8BE8C5" />,
      title: "Remember",
      description:
        "AI Squared continues the relationship – sending thank yous, reviews, and warm ‘We miss you’ notes.",
      glow: "rgba(139, 232, 197, 0.9)",
    },
  ];

  return (
    <section className="framework-section">
      <div className="framework-header">
        <h2>Our Proven Framework for Effortless Luxury</h2>
        <p>
          AI Squared redefines hospitality through intelligent simplicity. From the
          first message to the final goodbye, every interaction feels curated —
          personalized, seamless, and human.
        </p>
      </div>

      <div className="framework-line" />

      <div className="framework-grid">
        {cards.map((card, index) => (
          <FrameworkCard key={index} {...card} />
        ))}
      </div>

      <div className="framework-cta">
        <button>Experience AI Squared Luxury</button>
      </div>
    </section>
  );
}
